import { useState, type PropsWithChildren } from "react";
import { FieldDestinationContext } from "./FieldDestinationContext.ts";
import { createFieldDestinationStore } from "./fieldDestinationStore.ts";

const FieldDestinationProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(createFieldDestinationStore);
  return <FieldDestinationContext value={store}>{children}</FieldDestinationContext>;
};

export default FieldDestinationProvider;
